import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type UpdatePendingTypeChangeRequest,
  type UpdatePendingTypeChangeResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useUpdatePendingTypeChange = () => {
  const queryClient = useQueryClient();

  return useMutation<UpdatePendingTypeChangeResponse, unknown, UpdatePendingTypeChangeRequest>({
    mutationFn: (payload) => bulkInventoryBinService.updatePendingTypeChange(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.bulkInventoryBin.pendingDisposal(),
      });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
    },
  });
};
